import { withTopbarProps } from '@jusbrasil/topbar'
import { withUserSession } from '@jusbrasil-web/shared-user-session'
import { getFirstQueryParam } from '@jusbrasil-web/shared-utils-url'
import { GetServerSideProps } from 'next'
import { useRouter } from 'next/router'

import { internalAuthApi } from '../../api'
import { AuthLayout, EmailOtpConfirmation } from '../../components'
import { ROUTES } from '../../constants'
import { useSignupOtp } from '../../hooks/useSignupOtp'
import { getBasePath } from '../../utils/base-path'

export interface VerifyEmailOtpPageProps {
  email: string
  basePath: string
  csrfToken?: string | null
}

export function VerifyEmailOtpPage({ email, basePath }: VerifyEmailOtpPageProps) {
  const router = useRouter()
  const { isLoading, error, setError, validateCode, resendCode } = useSignupOtp({ email, basePath })

  const handleChangeEmail = () => {
    router.push({ pathname: ROUTES.SIGN_IN.BEGIN, query: { ...router.query, email } })
  }

  return (
    <AuthLayout>
      <EmailOtpConfirmation
        email={email}
        isLoading={isLoading}
        error={error}
        onComplete={validateCode}
        onResend={resendCode}
        onChangeEmail={handleChangeEmail}
        onCodeChange={() => setError(undefined)}
      />
    </AuthLayout>
  )
}

const getServerSideProps: GetServerSideProps = async (ctx) => {
  const email = getFirstQueryParam(ctx.query.email)
  const pathname = ctx.resolvedUrl?.split('?')[0] ?? ''
  const basePath = getBasePath(pathname)

  if (!email) {
    return {
      redirect: {
        destination: ROUTES.SIGN_UP.BEGIN,
        permanent: false,
      },
    }
  }

  const { csrfToken } = await internalAuthApi.getCsrfToken(ctx)

  return {
    props: {
      ...withTopbarProps(ctx),
      ...withUserSession(ctx),
      basePath,
      email,
      csrfToken,
    },
  }
}

export const VerifyEmailOtpPageExports = {
  getServerSideProps,
}
